import { collection, getDocs, limit, orderBy, query } from "firebase/firestore";
import { db } from "../firebase";

export type PtuLeader = {
  id?: string;
  name: string;
  role: string;
  bio?: string;
  imageUrl?: string;
  email?: string;
  sortOrder?: number;
  isPublished?: boolean;
};

const fallbackPtu: PtuLeader[] = [
  { name: "", role: "President" },
  { name: "", role: "Vice President" },
  { name: "", role: "Secretary" },
  { name: "", role: "Treasurer" },
];

function mapDoc(id: string, data: any): PtuLeader {
  return {
    id,
    name: String(data?.name ?? ""),
    role: String(data?.role ?? ""),
    bio: String(data?.bio ?? ""),
    imageUrl: String(data?.imageUrl ?? ""),
    email: String(data?.email ?? ""),
    sortOrder: Number(data?.sortOrder ?? 999),
    isPublished: data?.isPublished === true,
  };
}

export async function getPtuLeadership(options: { useFallback?: boolean } = {}): Promise<PtuLeader[]> {
  if (!db) return options.useFallback === false ? [] : fallbackPtu;
  try {
    const snap = await getDocs(query(collection(db, "publicPtuLeadership"), orderBy("sortOrder", "asc"), limit(100)));
    const items = snap.docs.map((item) => mapDoc(item.id, item.data())).filter((item) => item.isPublished);
    return items.length ? items : options.useFallback === false ? [] : fallbackPtu;
  } catch (error) {
    console.warn("[public-web] Failed to load publicPtuLeadership", error);
    return options.useFallback === false ? [] : fallbackPtu;
  }
}
